import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "../common/index.scss";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { mainSlider } from "../../services/script";
import { addToWishlist } from '../../actions/wishlist'
import * as landingActions from "../../actions/home";
import { getWebSessionId } from '../../actions/user';
// Import custom components

import ReactPlayer from "react-player";
import VideoPlayer from '../utils/videoPlayer';
import { toast } from 'react-toastify';
import VisibilitySensor from "react-visibility-sensor";

// Themes
import Banner from './themes/banner';
import BrandList from './themes/brands';
import ProductList from './themes/products';
import MiddleSection from './themes/middleSection';
import BlogList from './themes/blog';
import TopCollection from "./common/top-collection";
import TopCategories from "./common/top-categories";
import Influencer from "./common/influencer";
import AboutUs from './themes/aboutUs';
import ProductTutorial from './themes/productTutorial';
import SpecialOffer from './themes/specialOffer';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.scss";

//loading states
import TopCollectionLading from "../common/loading/topCollectionLoading";

class Home extends Component {
  constructor() {
    super()
    this.state = { matches: window.matchMedia("(min-width: 768px)").matches };
  }

  componentWillMount() {
    document.getElementById("color").setAttribute("href", `#`);
    const { getInfocuItems, presentURL, isAuth ,tenant_name}= this.props;
      if(isAuth){
        getWebSessionId(this.props.connection_id)
      }
    getInfocuItems(this.props.connection_id,tenant_name);
  }

  handleAddToWishlist = (item,) => {
    if (this.props.isAuth) {
      const { connection_id, consumer_mobile_no } = this.props
      const options = { connection_id, consumer_mobile_no, lot_code: item.LOT_CD }
      this.props.addToWishlist(options)
    }
    else {
      toast.error("Please login / Register to add items to Wishlist.");
      this.props.history.push('/login');
    }
  }

  render() {
    const {
      landingLoading,
      infocusPages,
      collections,
      influences,
      bannerText,
      headerText,
      sectionText,
      page_layout,
      InfluencerText
    } = this.props;
    let infocus_pages_array = [];

    if (landingLoading) {
      return (
        <div style={{ minHeight: "50vh" }}>
          <div className="loading-cls"></div>
        </div>
      );
    }

    let themeLayout = page_layout && page_layout[0].ADL_DESIGN_LAYOUT_DESC
    let themeLayoutId = page_layout && page_layout[0].ADL_DESIGN_LAYOUT_ID;
    // page_layout && page_layout[0].ADL_DESIGN_LAYOUT_ID
    let mainBanner = null
    let landingCategories = null

    if(themeLayoutId === 'L01'){
      // Fashion Theme
       mainBanner = (infocusPages && infocusPages.T01) || null;
      landingCategories = (infocusPages && infocusPages.T03 && infocusPages.T03) || {}
    }
    else if(themeLayoutId === 'L02'){
      // Furniture Theme
      mainBanner = (infocusPages && infocusPages.T001) || null;
      landingCategories = (infocusPages && infocusPages.T001 && infocusPages.T001) || {}
    }
    else if(themeLayoutId === 'L03'){
      // Furniture Theme
      mainBanner = (infocusPages && infocusPages.T01) || null;
      landingCategories = (infocusPages && infocusPages.T03 && infocusPages.T03) || {}
    }
    else if(themeLayoutId === 'L04'){
      // Furniture Theme
      mainBanner = (infocusPages && infocusPages.T01) || null;
      landingCategories = (infocusPages && infocusPages.T03 && infocusPages.T03) || {}
    }
    else if(themeLayoutId === 'L05'){
      // Furniture Theme
      mainBanner = (infocusPages && infocusPages.T01) || null;
      landingCategories = (infocusPages && infocusPages.T03 && infocusPages.T03) || {}
    }
    else{
      mainBanner = null
      landingCategories = null
    }

    return (
      <div className="home">
        <Helmet>
          <title>{this.props.customer_name}  | Home</title>
          <meta name="description" content="mango store" />
        </Helmet>

        {/*  Theme Design Start */}
       
          <Banner mainBanner = {mainBanner} themeLayoutId={themeLayoutId} matches={this.state.matches} />
          
          {(themeLayoutId === 'L01' || themeLayoutId === 'L02') &&
              <TopCategories
                items={landingCategories || []}
                themeLayoutId = {themeLayoutId || []}
                title={sectionText && sectionText[0] && sectionText[0].APC_ELEMENT_CONTENT}
              />
          }
          {(themeLayoutId === 'L04') &&
          <BrandList mainBanner = {mainBanner} themeLayoutId={themeLayoutId} />
          }
          
          <ProductList themeLayoutId={themeLayoutId} />

          <AboutUs mainBanner = {mainBanner} themeLayoutId={themeLayoutId} />
          
          {((themeLayoutId === 'L01') || (themeLayoutId === 'L02') || (themeLayoutId === 'L03') || (themeLayoutId === 'L04') || (themeLayoutId === 'L05')) &&
          <TopCollection 
          type={'women'} 
          items={collections} 
          themeLayoutId={themeLayoutId}
          title={collections[0] && collections[0].ACP_INFOCUS_COLLECTION_DESC} 
          addToWishlistClicked={this.handleAddToWishlist}
          />
          }
          
          <MiddleSection themeLayoutId={themeLayoutId} />
          <ProductTutorial mainBanner = {mainBanner} themeLayoutId={themeLayoutId} />
          
          {(themeLayoutId === 'L04' || themeLayoutId === 'L03') &&
          <TopCollection 
          type={'women'} 
          items={collections} 
          themeLayoutId={themeLayoutId}
          title={collections[0] && collections[0].ACP_INFOCUS_COLLECTION_DESC} 
          addToWishlistClicked={this.handleAddToWishlist}
          />
          }

          <SpecialOffer themeLayoutId={themeLayoutId} mainBanner={mainBanner} />

          {(themeLayoutId === 'L05') &&
          <BrandList mainBanner = {mainBanner} themeLayoutId={themeLayoutId} />
          }

          <BlogList mainBanner = {mainBanner} themeLayoutId={themeLayoutId} />
         

        {/* end Theme Design */}
        
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.user.isAuth,
  presentURL: state.tenant.presentURL,
  infocusPages: state.landing.infocusPages,
  collections: state.landing.collections,
  page_layout: state.landing.page_layout,
  influences: state.landing.influences,
  landingLoading: state.landing.loading,
  connection_id: state.tenant.connection_id,
  consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
  customer_name: state.tenant.tenant_details && state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
  bannerText:
  state.tenant.header_and_store_content && state.tenant.header_and_store_content.filter(
      (item) => item.APC_ELEMENT_ID === "Banner Description"
    ) || null,
  headerText:
  state.tenant.header_and_store_content && state.tenant.header_and_store_content.filter(
      (item) => item.APC_ELEMENT_ID === "Header Description"
    ) || null,
  sectionText:
  state.tenant.header_and_store_content &&  state.tenant.header_and_store_content.filter(
      (item) => item.APC_ELEMENT_ID === "Section Description"
    ) || null,
  InfluencerText:
  state.tenant.header_and_store_content && state.tenant.header_and_store_content.filter(
    (item) => item.APC_ELEMENT_ID === "Influencer Header Description"
  ) || null,
  storeSelected: state.store && state.store.selectedStore === null ? false : true,
  tenant_name : state.tenant.store_details && state.tenant.store_details.tenant_name
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInfocuItems: landingActions.getInfocusItems,
      addToWishlist,
      getWebSessionId,
      // updateUserInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Home);
